import { useTranslation } from 'react-i18next';
import { Card } from '../Card';
import { Heading } from '../Heading';
import { Form, Input, Typography } from 'antd';
import useOrderTypeStore, { OrderTypeEnum } from '@/stores/useOrderTypeStore';

const { TextArea } = Input;
const { Text } = Typography;

const DeliveryInstructionCard = () => {
  const { t } = useTranslation();
  // F3+F4: when order type is RETURN or EXCHANGE the driver must know what
  // to collect, so the delivery-instructions field becomes required and the
  // hint text changes to reflect the new rule.
  const orderType = useOrderTypeStore((s) => s.orderType);
  const isReturnOrExchange =
    orderType === OrderTypeEnum.RETURN || orderType === OrderTypeEnum.EXCHANGE;

  return (
    <Card>
      <Heading
        title={t('delivery_instruction')}
        fontSize='text-xs'
        fontWeight='font-bold'
        color='text-sd-muted-foreground'
        extraClassName='uppercase tracking-wider mb-1'
      />
      <Text className='text-xs text-sd-muted-foreground mb-3 block'>
        {t('if_you_have_any_special_delivery_instructions_please_enter_them_here')}
      </Text>
      <Form.Item
        name='deliveryInstruction'
        className='mb-0'
        rules={
          isReturnOrExchange
            ? [{ required: true, message: String(t('delivery_instructions_required_for_return_exchange')) }]
            : undefined
        }
      >
        <TextArea
          autoComplete='off'
          className='min-h-[80px] rounded-md border border-solid border-sd-input bg-sd-input-bg focus-visible:ring-2 focus-visible:ring-sd-ring focus-visible:ring-offset-2'
          placeholder={t('do_not_ring_door')}
          autoSize={{ minRows: 3, maxRows: 6 }}
        />
      </Form.Item>
    </Card>
  );
};

export default DeliveryInstructionCard;
